import { Intangible } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import { HotelViewModel } from '@api/v3';
import useGetasPath from '@hooks/useGetasPath';

// const DecimalToFraction = (decimal: number) => {
//   const gcd = (a: number, b: number): number => (b ? gcd(b, a % b) : a);

//   if (decimal % 1 === 0) return decimal.toString(); // Tam sayı kontrolü
//   const len = decimal?.toString().split('.')[1].length;
//   const denominator = Math.pow(10, len);
//   const numerator = decimal * denominator;
//   const divisor = gcd(numerator, denominator);

//   return `${numerator / divisor}/${denominator / divisor}`;
// };

export const HotelListSchemaOrg = ({
  hotel,
  name,
  destination,
}: {
  hotel: HotelViewModel[][];
  name?: string;
  destination: boolean;
}) => {
  const path = useGetasPath();

  const url = `${process.env.NEXT_PUBLIC_HOST}${path}`;

  return (
    <Script
      defer
      {...jsonLdScriptProps<Intangible>({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: name,
        url,
        itemListElement: hotel?.[0]?.map((item, index) => ({
          '@type': destination ? 'Hotel' : 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Hotel',
            name: item.name,
            url: `${process.env.NEXT_PUBLIC_HOST}/${item.url}`,
            image: item.image,
            aggregateRating:
              item?.ratings?.rating?.value &&
              item?.ratings?.rating?.totalReviewCount
                ? {
                    '@type': 'AggregateRating',
                    reviewCount: item?.ratings?.rating?.totalReviewCount,
                    ratingValue: Number(item?.ratings?.rating?.value),
                    bestRating: 5,
                    worstRating: 1,
                  }
                : undefined,
            address: {
              '@type': 'PostalAddress',
              streetAddress: item.location,
              addressLocality: item.city,
              addressCountry: item.country ? item.country : 'Türkiye',
            },
          },
        })),
      })}
    />
  );
};
